var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('a',{staticClass:"sr-only focus:not-sr-only",attrs:{"href":"#main-content"}},[_c('div',{staticClass:"bg-white px-4 py-1 fixed top-0 left-0 shadow-1"},[_vm._v("\n    Skip to main content\n  ")])])}]

export { render, staticRenderFns }